import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Test } from '../_model/test';
import { AnalyticsEvent } from '../_model/analytics-event';
import { ChangePassword } from '../_model/changepassword';
import { environment } from '../../environments/environment';

@Injectable()
export class APIService {

    constructor(private http: HttpClient) {
    }

    saveTest(test: Test): Observable<any> {
        const url: string = environment.apiUrl + '/test';
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        return this.http.post(url, test, {headers: headers, observe: "response"}).pipe(
            catchError(this.handleErrorObservable));
    }

    getTests(token: string): Observable<any> {
        const body = JSON.stringify({
            access_token: token,
            requestor: 'web',
        });
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        const url = environment.apiUrl + '/user/tests';

        return this.http.post(url, body, {headers}).pipe(
            catchError(this.handleErrorObservable));
    }

    private handleErrorObservable(error: HttpErrorResponse) {
        console.error(error.message || error);
        return observableThrowError(error.message || error);
    }

    getSessions(token: string): Observable<any> {
        const body = JSON.stringify({
            access_token: token,
            requestor: 'web',
        });
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        const url = environment.apiUrl + '/user/sessions';

        return this.http.post(url, body, {headers}).pipe(
            catchError(this.handleErrorObservable));
    }

    updatePassword(token: string, changePassword: ChangePassword): Observable<any> {
        const body = JSON.stringify({
            access_token: token,
            oldPassword: changePassword.oldPassword,
            newPassword: changePassword.newPassword,
            newPasswordConfirm: changePassword.newPasswordConfirm,
            requestor: 'web',
        });
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        const url = environment.apiUrl + '/user/updatepassword';
        return this.http.post(url, body, {headers: headers, observe: "response"}).pipe(
            catchError(this.handleErrorObservable));
    }

    delete(token: string, testID: number): Observable<any> {
        const body = JSON.stringify({
            access_token: token,
            action: 'delete',
            id: testID,
        });

        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        const url: string = environment.apiUrl + '/user/test';

        return this.http.post(url, body, {headers: headers, observe: "response"}).pipe(
            catchError(this.handleErrorObservable));
    }

    deleteSession(token: string): Observable<any> {
        const body = JSON.stringify({
            access_token: token,
            action: 'delete',
            requestor: 'web',
        });

        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        const url: string = environment.apiUrl + '/user/session';

        return this.http.post(url, body, {headers: headers, observe: "response"}).pipe(
            catchError(this.handleErrorObservable));
    }

    saveEvent(event: AnalyticsEvent): Observable<any> {
        const url: string = environment.apiUrl + '/event';
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        return this.http.post(url, event, {headers, responseType: 'blob'}).pipe(
            catchError(this.handleErrorObservable));
    }


}
